"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3260],{

/***/ 3260:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ ContactCard; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ../wif-ui-lib/dist/app-a75c1d35.mjs
var app_a75c1d35 = __webpack_require__(3406);
// EXTERNAL MODULE: ../wif-ui-lib/dist/CallToAction-d24a74ed.mjs
var CallToAction_d24a74ed = __webpack_require__(1416);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Block-9b78bd10.mjs
var Block_9b78bd10 = __webpack_require__(4877);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Link-479ac100.mjs
var Link_479ac100 = __webpack_require__(965);
;// CONCATENATED MODULE: ../wif-ui-lib/dist/ContactCard.js







const f = "contact-card", _ = "contact-card--single", x = "contact-card--multiple-first", B = "contact-card--multiple-second", h = "contact-card__title", y = "contact-card--description", S = "contact-card__phone", T = "contact-card__email", P = "contact-card__email--bottom", t = {
  contactCard: f,
  contactCardSingle: _,
  contactCardMultipleFirst: x,
  contactCardMultipleSecond: B,
  contactCardTitle: h,
  contactCardDescription: y,
  contactCardPhone: S,
  contactCardEmail: T,
  contactCardEmailBottom: P
}, L = [
  (0,app_a75c1d35.c)(t.contactCardTitle, app_a75c1d35.t.textsComponentTitleBold),
  (0,app_a75c1d35.c)(t.contactCardDescription, app_a75c1d35.t.textsLeadText),
  (0,app_a75c1d35.c)(t.contactCardPhone, app_a75c1d35.t.textsBodyText)
], M = ({
  title: a,
  description: r,
  phone: l,
  email: o,
  link: d,
  isSecondCard: m = !1,
  isMultipleCard: i = !1
}) => {
  const p = [a, r, l];
  return /* @__PURE__ */ react.createElement(
    "div",
    {
      className: (0,app_a75c1d35.c)(t.contactCard, {
        [t.contactCardSingle]: !i,
        [t.contactCardMultipleFirst]: i && !m,
        [t.contactCardMultipleSecond]: i && m
      })
    },
    p.map((u, C) => /* @__PURE__ */ react.createElement("p", { key: C, className: L[C] }, u)),
    /* @__PURE__ */ react.createElement(Link_479ac100.L, { href: `mailto:${o}`, disableLinkTextStyle: !0 }, /* @__PURE__ */ react.createElement(
      "p",
      {
        className: (0,app_a75c1d35.c)(
          t.contactCardEmail,
          d && t.contactCardEmailBottom
        )
      },
      o
    )),
    d && /* @__PURE__ */ react.createElement(CallToAction_d24a74ed.C, { text: "Learn more", to: d, isBlueBackground: !0 })
  );
};
function v({ contacts: a }) {
  const r = a.length > 2 ? a.slice(0, 2) : a;
  return /* @__PURE__ */ react.createElement(Block_9b78bd10.B, { topPadding: Block_9b78bd10.B.Padding.NONE, bottomPadding: Block_9b78bd10.B.Padding.LARGE }, /* @__PURE__ */ react.createElement(Block_9b78bd10.B.Content, null, r.map((l, o) => /* @__PURE__ */ react.createElement(
    M,
    {
      key: o,
      ...l,
      isMultipleCard: a.length > 1,
      isSecondCard: o === 1
    }
  ))));
}

//# sourceMappingURL=ContactCard.js.map

;// CONCATENATED MODULE: ./src/magnolia/components/ContactCard/ContactCard.tsx


function ContactCard(param) {
    var contacts = param.contacts;
    if (contacts["@nodes"].length) {
        var contactLists = contacts["@nodes"].map(function(nodeId) {
            var contact = contacts[nodeId];
            return {
                title: contact.title,
                description: contact.description,
                phone: contact.phone,
                email: contact.email,
                link: contact.link
            };
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v, {
                contacts: contactLists
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
}

;// CONCATENATED MODULE: ./src/magnolia/components/ContactCard/index.ts
/* istanbul ignore file */ 


/***/ })

}]);